module.exports = __webpack_public_path__ + "img/company_list.1cfebc01.png";